//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'vant';
export default {
  name: 'calendar',
  components: {
    [Toast.name]: Toast
  },
  data() {
    return {
      isnMonths: new Array("1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"),
      isnDays: new Array("日", "一", "二", "三", "四", "五", "六"),
      date: '',
      firstdate: '',
      d: '',
      m: '',
      y: '',
      selectedDate: "",
      hoursNums: 0,
      now_year_month: '',
      alldays: [],
      momth_a: 0,
      getDateType: '',
      getFlowerDate: '',
      deliveryPeriod: '7',
      closeTime: '',
      year_a: '',
      day_a: '',
      time_page: new Date(),
      date_c: '',
      date_table: '',
      obj_arr: [],
      dateObj: {},
      active_show: false,
      out_data: [],
      dataWeek: null,
      // 分天库存售罄的数组
      nodata: [],
      firstFlowDate: ""
    }
  },
  computed: {

  },
  props: {
    greenFirst: {
      type: String,
      value: "aaaaaaaa",
      observer: function(newVal, oldVal) {
        if (newVal != oldVal) {
          this.setdate(this.greenFirst);
          this.getValidDates();
          this.drewtable();
          var eventdetail = {
            out_data: this.out_data
          };
          var eventdetailOption = {
            bubbles: true
          } // 触发事件的选项
          this.triggerEvent('getValidDates', eventdetail, eventdetailOption);
        }
      }
    },
    advanceDate: {
      type: String,
      value: null,
      observer: function(newVal, oldVal) {
        if (newVal != oldVal) {
          this.setdate(this.advanceDate);
          this.getValidDates();
          this.drewtable();
          var eventdetail = {
            out_data: this.out_data
          };
          var eventdetailOption = {
            bubbles: true
          } // 触发事件的选项
          // this.triggerEvent('getValidDates', eventdetail, eventdetailOption);
        }
      }
    },
    currentTime: Number,
    showCal: Boolean,
    show_car: {
      type: Boolean,
      value: false
    },
    isCycle: {
      type: Boolean,
      value: false,
    },
    isPresell: Number,
    presellDate: {
      type: String,
      value: null,
    },
    latestDateFirst: {
      type: String,
      value: null,
    },
    receiveDate: {
      type: String,
      value: null,
      observer: function(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getValidDates();
          this.drewtable();
          var eventdetail = {
            out_data: this.out_data
          };
          var eventdetailOption = {
            bubbles: true
          } // 触发事件的选项
          // this.triggerEvent('getValidDates', eventdetail, eventdetailOption);
        }
      }
    },
    endDateType: String,
    displayType:Number,
    receiveType: {
      type: Number,
      value: null,
      observer: function(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getValidDates();
          this.drewtable();
          var eventdetail = {
            out_data: this.out_data
          };
          var eventdetailOption = {
            bubbles: true
          } // 触发事件的选项
          // this.triggerEvent('getValidDates', eventdetail, eventdetailOption);
        }
      }
    },

    dateInput: {
      type: String,
      value: "aaaaaaaa",
      observer: function(newVal, oldVal) {
        if (newVal != oldVal) {
          this.setdate(this.dateInput);
          this.getValidDates();
          this.drewtable();
          var eventdetail = {
            out_data: this.out_data
          };
          var eventdetailOption = {
            bubbles: true
          } // 触发事件的选项
          // this.triggerEvent('getValidDates', eventdetail, eventdetailOption);
        }
      }
    },
    dayStock: {
      type: Array,
      observer: function(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getValidDates();
          this.drewtable();
          var eventdetail = {
            out_data: this.out_data
          };
          var eventdetailOption = {
            bubbles: true
          } // 触发事件的选项
          // this.triggerEvent('getValidDates', eventdetail, eventdetailOption);
        }
      }
    },
    eskuIdList: {
      type: String,
      observer: function(newVal, oldVal) {
        if (newVal != oldVal) {
          var eventdetail = {
            out_data: this.out_data
          };
          var eventdetailOption = {
            bubbles: true
          } // 触发事件的选项
        }
      }
    },
    excludeCycleTime: {
      type: Object,
      observer: function(newVal, oldVal) {
        if (newVal != oldVal) {
          var eventdetail = {
            out_data: this.out_data
          };
          var eventdetailOption = {
            bubbles: true
          } // 触发事件的选项
        }
      }
    },
    gid: {
      type: Number,
      value: 0,
    },
  },
  methods: {
    //获取当前时间
    getNowTime: function() {
      var date = new Date();
      var seperator1 = "-";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
        " "
      return currentdate;
    },

    update: function() {
      this.showCal = "show_c";
    },

    cancelCar: function() {
      this.show_car = false;
    },
    confirm: function() {

      var dataWeek = this.dataWeek
      // var myEventDetail = { dataWeek } // detail对象，提供给事件监听函数
      // var myEventOption = { bubbles: true } // 触发事件的选项
      // this.triggerEvent('seldate', myEventDetail, myEventOption);
      this.$emit("seldate", dataWeek)

    },

    getfirstdate: function() {

      var numd = this.firstdate;
      numd = new Date(numd);
      var nums = numd.getDay();

      var date_t = new Date(this.y, this.m, 1 - nums);
      return date_t;
    },
    getNowStr: function(stag) {
      var y_t = date.getFullYear();
      var m_t = date.getMonth() + 1;
      var m_d = date.getDate();
      var m_h = date.getHours();
      var m_m = date.getMinutes();
      return y_t +
        stag +
        (m_t > 9 ? m_t : ("0" + m_t)) +
        stag +
        (m_d > 9 ? m_d : ("0" + m_d)) +
        " " +
        (m_h > 9 ? m_h : "0" + m_h) +
        ":" +
        (date.getMinutes() > 9 ? date.getMinutes() : "0" +
          m_m) + ":00";
    },

    getlastdate: function() {
      var nums = showdays() - this.firstdate.getDay() - this.getDays(this.y, this.m);
      var date_t = new Date(y, m, getDays(y, m) + nums);
      return date_t;
    },
    getdatestring: function(date_t) {
      return date_t.getFullYear() +
        "-" +
        (date_t.getMonth() + 1 > 9 ? (date_t.getMonth() + 1) :
          ("0" + (date_t.getMonth() + 1))) +
        "-" +
        (date_t.getDate() > 9 ? date_t.getDate() : ("0" + date_t.getDate()));
    },

    getDays: function(a, b) {
      var d = Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
      return b == 1 ? a % 4 == 0 && a % 100 != 0 || a % 400 == 0 || a < 1900 ? 29 :
        d[b] :
        d[b]
    },

    getpdays: function() {
      var days = Array();

      var numd = this.firstdate;
      numd = new Date(numd);
      var nums = numd.getDay();
      var t_date = this.firstdate;
      var m = this.m;
      var max_day = 0;
      if (m == 0) {
        max_day = this.getDays(this.y - 1, 11);
      } else {
        max_day = this.getDays(this.y, this.m - 1);
      }
      var days = new Array();
      for (var i = 0; i < nums; i++) {
        days.unshift(max_day - i);
      }
      return days;
    },
    getndays: function() {
      var t_date = new Date(this.y, this.m + 1, 1);
      var numd = this.firstdate
      numd = new Date(numd);
      var nums = this.showdays() - numd.getDay() -
        this.getDays(this.y, this.m);
      var max_day = this.getDays(t_date.getFullYear(), t_date.getMonth());
      var days = new Array();
      for (var i = 1; i <= nums; i++) {
        days.push(i);
      }
      return days;
    },
    setdate: function(t_date) {
      var date = new Date(t_date);
      var d = date.getDate();
      var m = date.getMonth();
      var y = date.getFullYear();
      var firstdate = new Date(y, m, 1);
      var params = {
        "d": d,
        "m": m,
        "y": y,
        "firstdate": firstdate
      };
      this.d = d;
      this.m = m;
      this.y = y;
      this.firstdate = firstdate;
    },
    getnweek: function() {
      return isnDays[this.firstdate.getDay()];
    },

    next: function() {
      this.obj_arr = [];
      var t_date = new Date(this.y, this.m + 1, 1);
      this.setdate(t_date);
      this.drewtable();
    },
    pre: function() {
      this.obj_arr = [];
      var t_date = new Date(this.y, this.m - 1, 1);
      this.setdate(t_date);
      var firstdate = new Date(this.y, this.m, 1);
      this.firstdate = firstdate;
      this.drewtable();
    },
    showdays: function() {
      var days = this.firstdate.getDay() + this.getDays(this.y, this.m);
      return Math.ceil(days / 7) * 7;
    },

    gethoursNums: function() {
      var currTime;
      console.log("当前时间-----------", this.currentTime)
      var currentTime = parseInt(this.currentTime)
      var sysTime = new Date(currentTime);
      var presellDate = new Date(Date.parse(this.presellDate));
      if (this.isPresell == 1 && presellDate > sysTime) {
        sysTime = presellDate;
      }

      this.year_a = sysTime.getFullYear();
      this.month_a = sysTime.getMonth();
      this.day_a = sysTime.getDate();

      var hoursNums = sysTime.getHours();
      this.hoursNums = hoursNums;
      return parseInt(hoursNums);
    },

    isValidDay: function(currDate) {
      var flag = false;
      var hoursNums = this.hoursNums;

      var closeDay = this.endDateType.split("|");

      var int1 = parseInt(closeDay[0]);
      if (closeDay.length > 1) {
        var int2 = parseInt(closeDay[1]);
      }

      var forbidden_date = new Array();
      var nodata = [];
      if (this.dayStock != null) {
        for (let temp of this.dayStock) {
          if (this.getdatestring(currDate) == temp.date && temp.stockBalance <= 0) {
            forbidden_date.push(temp.date)

          }
        };
      }

      let limitDateArr = []
      let eskuIdLimit = []
      let eskuIdDateList = this.eskuIdList.split('|')
      for (let n in this.excludeCycleTime) {
                //不屏蔽指定gid
                if(n == "excludeSpus"){
                  let excludeSpusStr = this.excludeCycleTime[n];
                  let excludeSpusStrArr = excludeSpusStr.split(',');
                  if(excludeSpusStrArr.length > 0){
                    //包含该gid 不屏蔽日期
                    if(excludeSpusStrArr.indexOf(this.gid) > -1){
                      return;
                    }
                  }
                }
        // 周期花屏蔽日期
        if (n == 'date') {
          let dataStr = this.excludeCycleTime[n]
          forbidden_date = forbidden_date.concat(dataStr.split(','))
        }

        for (let k = 0; k < eskuIdDateList.length; k++) {
          if (n == eskuIdDateList[k]) {
            let transArr = this.excludeCycleTime[n].split(',')
            forbidden_date = forbidden_date.concat(transArr)
          }
        }
      }

      //如果是周期商品 指定了首期收花截止日期
      if(this.isCycle && this.latestDateFirst != null){
        if (Date.parse(currDate) > this.latestDateFirst ) {
          return false;
        }
      }


      if (this.receiveType == 13) {
        //屏蔽周期花日期
        for (var fi = 0, len = forbidden_date.length; fi < len; fi++) {
          var f_date = forbidden_date[fi];
          if (this.getdatestring(currDate) == f_date) {
            return false;
          }
        };

        var valid_date = new Date(this.year_a, this.month_a, this.day_a + int1);
        var iii = 0;
        if (hoursNums > (int2 - 1)) {
          var valid_date = new Date(this.year_a, this.month_a, this.day_a + (int1 + 1));
          iii = iii + 1;
        }
        var rds = this.receiveDate.split("|");
        var cday = currDate.getDay();
        if (valid_date > currDate) {
          return false;
        }
        if (this.advanceDate) {
          // 第一个要显示的日期 预售
          var xzyy = new Date(this.greenFirst).getFullYear();
          var xzym = new Date(this.greenFirst).getMonth() + 1;
          var xzyd = new Date(this.greenFirst).getDate();
          if (new Date(xzyy + '-' + xzym + '-' + (xzyd + iii)) > currDate) {
            return false;
          }
        }
        //如果是定金预售活动
        if(this.displayType == 102){
          var xzyy = new Date(this.greenFirst).getFullYear();
          var xzym = new Date(this.greenFirst).getMonth() + 1;
          var xzyd = new Date(this.greenFirst).getDate();
          if (new Date((xzyy + '-' + xzym + '-' + (xzyd + iii)).replace(/-/g, "/")).getTime() > currDate.getTime()) {
            return false;
          }
        }
        for (var i = 0; i < rds.length; i++) {
          var weekNumb = rds[i];
          if (weekNumb == 7) {
            weekNumb == 0;
          }
          weekNumb = parseInt(weekNumb);
          if (weekNumb == cday) {
            if (this.firstFlowDate == "") {
              this.firstFlowDate = this.getdatestring(currDate)
            }
            return true;
          }
        }

      }

      if (this.receiveType == 12) {
        var int1 = parseInt(closeDay[0]);
        var int2 = parseInt(closeDay[1]);

        var valid_date = new Date(this.year_a, this.month_a, this.day_a + int1);

        var rds = this.receiveDate.split("|");
        if (hoursNums > (int2 - 1)) {
          var valid_date = new Date(this.year_a, this.month_a, this.day_a + (int1 + 1));
        }

        var vpt = valid_date.getTime();
        var cpt = currDate.getTime();

        for (var i = 0; i < rds.length; i++) {
          var time_t = rds[i];
          var pt = new Date(time_t.replace(/-/g, "/")).getTime();
          if (cpt >= valid_date && cpt == pt) {

            if (this.firstFlowDate == "") {
              this.firstFlowDate = this.getdatestring(currDate)
            }
            return true;
          }
        }
        return false;
      }
      if (this.receiveType == 11) {
        var closeDayOne = parseInt(this.endDateType);

        var valid_date = new Date(this.year_a, this.month_a, this.day_a + closeDayOne)
          .getTime();
        var rds = this.receiveDate.split("-");
        var int1 = parseInt(rds[0]);
        var int2 = parseInt(rds[1]);
        var bt = new Date(this.year_a, this.month_a, this.day_a + int1).getTime();
        var et = new Date(this.year_a, this.month_a, this.day_a + int2).getTime();
        var ct = currDate.getTime();
        if (ct >= bt && ct <= et) {
          if (this.firstFlowDate == "") {
            this.firstFlowDate = this.getdatestring(currDate)
          }
          return true;
        }
        return false;
      }
      if (this.receiveType == 14) {
        // var int1 = parseInt(closeDay[0]);
        // var int2 = parseInt(closeDay[1]);

        // var valid_date = new Date(this.year_a, this.month_a, this.day_a + int1);

        // var rds = this.receiveDate.split("-");
        // if (hoursNums > (int2 - 1)) {
        //   var valid_date = new Date(this.year_a, this.month_a, this.day_a + (int1 + 1));
        // }

        // var vpt = valid_date.getTime();
        // var cpt = currDate.getTime();
        // for (var i = 0; i < rds.length; i++) {
        //   var time_t = rds[i];
        //   var pt = new Date(time_t.replace(/-/g, "/")).getTime();
        //   if (cpt >= valid_date && cpt == pt) {
        //     console.log(time_t, 'pt')
        //     if (this.firstFlowDate == "") {
        //       this.firstFlowDate = this.getdatestring(currDate)
        //     }
        //     return true;
        //   }
        // }
        // return false;
        var closeDayOne = parseInt(this.endDateType);

        var valid_date = new Date(this.year_a, this.month_a, this.day_a + closeDayOne)
          .getTime();
        var rds = this.receiveDate.split("-");
        var int1 = parseInt(rds[0]);
        var int2 = parseInt(rds[1]);
        var bt = new Date(this.year_a, this.month_a, this.day_a + int1).getTime();
        var et = new Date(this.year_a, this.month_a, this.day_a + int2).getTime();
        var ct = currDate.getTime();
        if (ct >= bt && ct <= et) {
          if (this.firstFlowDate == "") {
            this.firstFlowDate = this.getdatestring(currDate)
          }
          return true;
        }
        return false;

      }


      var eventdetail = {
        '1245': 1345
      };
      var eventdetailOption = {
        bubbles: true
      } // 触发事件的选项
      // this.triggerEvent('other', eventdetail, eventdetailOption);


    },
    getValidDates: function() {
      this.gethoursNums();

      var data_begin = new Date(this.year_a, this.month_a, this.day_a);

      var limit = 100;
      var out = [];
      var nextDate = new Date(data_begin.getTime() + 24 * 60 * 60 * 1000);
      while (limit > 0) {
        // var nextDate = new Date(nextDate1.getTime() + 24 * 60 * 60 * 1000);
        if (this.isValidDay(nextDate)) {
          if (out.length < 3) {
            out.push(nextDate);
          } else {
            break;
          }
        }
        limit--;
      }
      this.out_data = out;

    },
    drewtable: function() {
      this.gethoursNums();
      var out_str = "";
      var arr_p = this.getpdays();
      var arr_n = this.getndays();
      var days_c = this.getarraycurdays();
      var alldays = arr_p.concat(days_c, arr_n);
      var obj_arr = [];
      var data_begin = this.getfirstdate();
      var n_p = arr_p.length;
      var n_c = days_c.length;
      var n_n = arr_n.length;

      //格式化数据 把天数数字 格式成对应对象数组，对象包含有对应的日期数字
      for (var index in alldays) {
        var a = {};
        a.num = alldays[index];
        obj_arr.push(a);
      }

      var alldays_length = alldays.length;
      if (alldays_length < 42) {
        var last = alldays[alldays_length - 1];
        if (this.getDays(this.y, this.m) == last) {
          last = 0;
        }

        for (var i = alldays_length + 1; i <= 42; i++) {
          last++;
          alldays.push(last);

        }
      }

      //判断当月的天数哪天可选和哪天不可选
      for (var index in obj_arr) {

        if (index < n_p || (index > (n_p + n_c - 1)) ||
          !this.isValidDay(data_begin)) {

          obj_arr[index].chk = false;

        } else {
          obj_arr[index].chk = true;
        }
        obj_arr[index].begin = data_begin;

        obj_arr[index].dateStr = this.getdatestring(data_begin);
        if (this.getdatestring(obj_arr[index].begin) == this.firstFlowDate) {
          obj_arr[index].active_show = true;
        }
        var nodata = [];
        if (this.dayStock != null) {
          for (let temp of this.dayStock) {
            if (temp.stockBalance <= 0) {
              nodata.push(temp);
            }
          };
        }

        this.nodata = nodata

        for (var n = 0; n < this.nodata.length; n++) {
          if (obj_arr[index].dateStr == this.nodata[n].date) {

            // obj_arr[index].notext ='售罄' ;
            obj_arr[index].nonum = true;
            obj_arr[index].num = '售罄';
          }
        }
        if (this.getdatestring(obj_arr[index].begin) == this.firstFlowDate) {
          obj_arr[index].active_show = true;
        }

        data_begin = new Date(data_begin.getFullYear(), data_begin
          .getMonth(), data_begin.getDate() + 1);
      }
      this.obj_arr = obj_arr;
    },

    getnmonth: function() {
      return this.date.getDate();
    },
    getarraycurdays: function() {
      var nums_t = this.getDays(this.y, this.m);
      var arr = new Array();
      for (var i = 1; i <= nums_t; i++) {
        arr.push(i);
      }
      return arr;
    },
    nextMonth: function() {
      this.next();
    },
    preMonth: function() {
      this.pre();
    },
    selDate(idx, dateStr) {
      var wk = '';
      if (idx % 7 == 0) {
        wk = '周日'
      } else if (idx % 7 == 1) {
        wk = '周一'
      } else if (idx % 7 == 2) {
        wk = '周二'
      } else if (idx % 7 == 3) {
        wk = '周三'
      } else if (idx % 7 == 4) {
        wk = '周四'
      } else if (idx % 7 == 5) {
        wk = '周五'
      } else if (idx % 7 == 6) {
        wk = '周六'
      }
      const obj_arr = this.obj_arr;
      if (!obj_arr[idx].chk) {
        return
      }

      for (var index in obj_arr) {
        obj_arr[index].active_show = false;
      }
      obj_arr[idx].active_show = !obj_arr[idx].active_show;
      this.obj_arr = obj_arr;
      this.selectedDate = dateStr;
      var dataWeek = dateStr + '' + wk;
      this.dataWeek = dataWeek;

      this.$forceUpdate(); //刷新界面

      console.log(this.isCycle, 'isCycle')
      if ((dateStr == "2022-12-19" || dateStr == "2022-12-26" || dateStr == "2023-01-02") && this.isCycle) {
        Toast({message:'您的订单有涉及元旦收花调整，1月2日周一自动顺延至1月3日周二。',duration: 5000,});

      }
      if(dateStr == "2024-09-16") {
        Toast({message:'重要提醒： 受中秋假期影响，9.16（周一）将调整为 9.14（周六）收花，请您合理安排时间！',duration: 5000,});

      }
    },
    onother: function() {
      this.setdate(this.dateInput);
      this.getValidDates();
      this.drewtable();

    }
  },
  created() {
    this.setdate(this.dateInput);

    this.getValidDates();
    this.drewtable();
    var myEventDetail = {} // detail对象，提供给事件监听函数
    var myEventOption = {
      bubbles: true
    } // 触发事件的选项
    // this.triggerEvent('seldate', myEventDetail, myEventOption);
    console.log(this.out_data, 'this.out_data')
    var eventdetail = {
      out_data: this.out_data
    };
    var eventdetailOption = {
      bubbles: true
    } // 触发事件的选项
    // this.triggerEvent('getValidDates', eventdetail, eventdetailOption);

    this.receiveDate;
    this.endDateType;
    this.receiveType;
    this.dateInput;
    this.greenFirst;
    this.advanceDate;
    this.presellDate;
    this.dayStock;
    this.currentTime;
    this.isCycle;
    this.eskuIdList;
    this.excludeCycleTime;

    console.log("111111")
  },
  watch: {
    greenFirst: function() {
      this.setdate(this.dateInput);

      this.getValidDates();
      this.drewtable();
      var myEventDetail = {} // detail对象，提供给事件监听函数
      var myEventOption = {
        bubbles: true
      } // 触发事件的选项
      // this.triggerEvent('seldate', myEventDetail, myEventOption);
      console.log(this.out_data, 'this.out_data')
      var eventdetail = {
        out_data: this.out_data
      };
      var eventdetailOption = {
        bubbles: true
      } // 触发事件的选项



    }
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar.vue